/**
 * "Passwort ändern" (U16): every teacher changes their own password with
 * the old one. The server ends all other logins of the account; this one
 * stays. Errors show in the dialog, which stays open.
 */
import { api } from '@shared/api';
import { qs } from '@shared/dom';
import { t } from '@shared/i18n/de';
import { openDialog } from '@shared/ui/dialog';
import { toast, errorMessage } from '@shared/ui/toast';

export async function openPasswordDialog(): Promise<void> {
  const dialog = openDialog({
    title: t('password.title'),
    body: `<label class="field">${t('password.old')}<input name="old" type="password" autocomplete="current-password" maxlength="256" required /></label>
      <label class="field">${t('password.new')}<input name="new" type="password" autocomplete="new-password" minlength="10" maxlength="256" required /></label>
      <label class="field">${t('password.repeat')}<input name="repeat" type="password" autocomplete="new-password" maxlength="256" required /></label>
      <p class="muted">${t('password.hint')}</p>
      <p class="error" data-error role="alert"></p>`,
    actions: [
      { label: 'Abbrechen', value: 'cancel', kind: 'ghost' },
      { label: t('password.save'), value: 'ok' },
    ],
    onSubmit: async (form) => {
      const value = (name: string): string => qs<HTMLInputElement>(form, `[name="${name}"]`).value;
      const error = qs(form, '[data-error]');
      error.textContent = '';
      if (value('old') === '') error.textContent = t('password.needOld');
      else if (value('new').length < 10) error.textContent = t('password.tooShort');
      else if (value('new') !== value('repeat')) error.textContent = t('password.mismatch');
      if (error.textContent !== '') return false;
      try {
        await api('/api/me/password', {
          method: 'POST',
          body: { oldPassword: value('old'), newPassword: value('new') },
        });
        return true;
      } catch (err) {
        error.textContent = errorMessage(err);
        return false;
      }
    },
  });
  if ((await dialog.result) === 'ok') toast(t('password.saved'));
}
